import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TeacherVM } from "@shared-kernel/application/ports/student/student-repository";
import { retrieveTeachers } from "./retrieve-teachers";

const initialState: RetrievalState<TeacherVM[]> = { fetching: "idle", data: [] };

export const studentRetrieveTeachersReducer = createReducer<RetrievalState<TeacherVM[]>>(initialState, builder => {
  builder.addCase(retrieveTeachers.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveTeachers.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveTeachers.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
